import { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

const maquinarias = [
  {
    id: 1,
    nombre: "Grúa Grove Modelo GMK4100 100Ton",
    patente: "GX-PB-24",
    color: "Azul",
    desc: "Grúa todo terreno Grove GMK4100 de 4 ejes con capacidad de 100 toneladas. Pluma principal telescópica MEGATRAK de 60 metros con extensión de plumín abatible para mayor versatilidad. Sistema de control ECOS con monitoreo inteligente de carga. Ideal para montajes industriales, obras de infraestructura y proyectos mineros de mediana envergadura. Incluye operador certificado y certificaciones al día.",
    img: "https://storage.readdy-site.link/project_files/5397651f-fa4a-4daf-a2cb-668ede89c5b0/305e872f-b7e9-4289-8a5c-538a2782042b_WhatsApp-Image-2023-08-22-at-16.54.03.jpeg?v=ce6369254d5fc623c6deef08c2ea15d9",
    tags: ["100 Ton", "4 Ejes", "Pluma 60m", "Con operador"],
  },
  {
    id: 2,
    nombre: "Grúa Grove Modelo GMK3055 - 55Ton",
    patente: "HH-DB-76",
    color: "Roja",
    desc: "Grúa todo terreno Grove GMK3055 de 3 ejes con capacidad de 55 toneladas. Diseño compacto y alta maniobrabilidad que permite operar en espacios reducidos y zonas urbanas. Pluma principal de 43 metros con plumín plegable lateral. Sistema hidráulico de precisión con estabilizadores independientes. Perfecta para obras de construcción civil, mantenimiento industrial y trabajos en recintos confinados. Incluye operador certificado.",
    img: "https://storage.readdy-site.link/project_files/5397651f-fa4a-4daf-a2cb-668ede89c5b0/de0da41d-28e4-4797-82fd-8124d9c28adc_WhatsApp-Image-2026-04-14-at-10.36.43-AM.jpeg?v=b5d122a8b7a2d0936494f5bee46360cb",
    tags: ["55 Ton", "3 Ejes", "Compacta", "Con operador"],
  },
  {
    id: 4,
    nombre: "Grúa Grove Modelo GMK5165 - 150Ton",
    patente: "CB-XK-62",
    color: "Amarilla",
    desc: "Grúa todo terreno Grove GMK5165 de 5 ejes con capacidad de 150 toneladas, la de mayor potencia de nuestra flota. Pluma principal MEGATRAK de 68 metros con plumín abatible de hasta 39 metros. Sistema TWIN-LOCK de doble pasador para máxima seguridad en izajes críticos. Tracción 10x8 con suspensión MEGATRAK independiente. Diseñada para grandes proyectos mineros, montajes de estructuras metálicas y obras industriales de alta exigencia. Incluye operador certificado con especialización en izajes complejos.",
    img: "https://storage.readdy-site.link/project_files/5397651f-fa4a-4daf-a2cb-668ede89c5b0/96dafae4-11e0-415b-9f1b-ffb23ea8fa00_WhatsApp-Image-2023-08-22-at-16.54.033.jpeg?v=65485cb88a21bbb6df8f99bf96711a17",
    tags: ["150 Ton", "5 Ejes", "Pluma 68m", "Con operador"],
  },
  {
    id: 5,
    nombre: "Grua Grove Modelo GMK3055 - 55Ton",
    patente: "GC-WG-87",
    color: "Azul",
    desc: "Grúa todo terreno Grove GMK3055 de 3 ejes con capacidad de 55 toneladas. Equipada con pluma principal telescópica de 43 metros y plumín abatible de 9 metros. Sistema de contrapesos modulares para rápida configuración en terreno. Estabilizadores de despliegue variable con control electrónico de nivelación. Especialmente indicada para faenas de construcción, descarga de materiales y apoyo logístico en obras industriales. Incluye operador certificado y mantenciones al día.",
    img: "https://storage.readdy-site.link/project_files/5397651f-fa4a-4daf-a2cb-668ede89c5b0/1781e2ad-2375-4e40-ad3e-d88cb130da78_WhatsApp-Image-2026-04-14-at-10.36.44-AM-2.jpeg?v=c04b022d4c21da38f4eadbfd42c967dc",
    tags: ["55 Ton", "3 Ejes", "Contrapesos modulares", "Con operador"],
  },
  {
    id: 6,
    nombre: "Grúa Grove RT 700E",
    patente: "FX-ZK-15",
    color: "Amarilla",
    mostrarPatente: false,
    desc: "Grúa rough terrain Grove RT 700E de 4x4 con capacidad de 70 toneladas. Diseñada específicamente para terrenos irregulares y faenas mineras en zonas de difícil acceso. Pluma telescópica de alta resistencia con sistema de extensión hidráulica. Tracción integral y neumáticos de gran diámetro para máximo agarre en terrenos accidentados. Ideal para montajes pesados, movimientos de maquinaria y trabajos en faenas mineras donde el acceso es limitado. Incluye operador certificado.",
    img: "https://static.readdy.ai/image/1a54e80d3a3f7c913cb3598862bec6f0/ecaae71660801b20a9975dd8d70279fd.jpeg",
    tags: ["70 Ton", "4x4", "Rough Terrain", "Con operador"],
  },
  {
    id: 7,
    nombre: "Grúa Grove RT 635C",
    patente: "PL-MN-23",
    color: "Amarilla",
    mostrarPatente: false,
    desc: "Grúa rough terrain Grove RT 635C compacta de 4x4 con capacidad de 35 toneladas. Diseño robusto y maniobrable para operar en espacios reducidos y terrenos irregulares. Pluma principal de gran resistencia con sistema de cabrestante de precisión. Chasis reforzado y neumáticos todo terreno para máxima estabilidad. Perfecta para faenas de mantenimiento industrial, montajes ligeros y trabajos en construcción donde el acceso con grúas convencionales es complicado. Incluye operador certificado.",
    img: "https://static.readdy.ai/image/1a54e80d3a3f7c913cb3598862bec6f0/0c723ca065c48cd873de31bdb76815a4.jpeg",
    tags: ["35 Ton", "4x4", "Compacta", "Con operador"],
  },
  {
    id: 8,
    nombre: "Grúa Grove RT 650E",
    patente: "JK-LM-45",
    color: "Amarilla",
    mostrarPatente: false,
    desc: "Grúa rough terrain Grove RT 650E de 4x4 con capacidad de 50 toneladas. Equipada con pluma telescópica de largo alcance y sistema de izaje de alta precisión. Diseño robusto con cabinas ergonómicas para mayor comodidad del operador. Sistema de estabilización con patas hidráulicas para operaciones seguras en terrenos desnivelados. Ideal para obras de construcción, montaje de estructuras y trabajos en faenas donde la movilidad off-road es esencial. Incluye operador certificado.",
    img: "https://static.readdy.ai/image/1a54e80d3a3f7c913cb3598862bec6f0/ab5be68aa7b17798bab8f2c3de7abb82.jpeg",
    tags: ["50 Ton", "4x4", "Rough Terrain", "Con operador"],
  },
  {
    id: 9,
    nombre: "Grúa Grove GMK 3050",
    patente: "GH-TR-88",
    color: "Amarilla/Gris",
    mostrarPatente: false,
    desc: "Grúa todo terreno Grove GMK 3050 de 3 ejes con capacidad de 50 toneladas. Versátil diseño que permite operar tanto en carretera como en terrenos irregulares sin necesidad de transporte especial. Pluma principal telescópica con múltiples configuraciones de plumín. Sistema de contrapesos intercambiables y estabilizadores hidráulicos de rápido despliegue. Ideal para proyectos de construcción civil, montajes industriales y faenas que requieren movilidad entre distintos puntos de obra. Incluye operador certificado.",
    img: "https://static.readdy.ai/image/1a54e80d3a3f7c913cb3598862bec6f0/284b85fe3590fa7bcd7bbf4c5ff7c78a.jpeg",
    tags: ["50 Ton", "3 Ejes", "Todo Terreno", "Con operador"],
  },
];

export default function ArriendoMaquinarias() {
  const sectionRefs = useRef<(HTMLDivElement | null)[]>([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("opacity-100", "translate-y-0");
            entry.target.classList.remove("opacity-0", "translate-y-8");
          }
        });
      },
      { threshold: 0.1 }
    );
    sectionRefs.current.forEach((ref) => {
      if (ref) observer.observe(ref);
    });
    return () => observer.disconnect();
  }, []);

  const addRef = (el: HTMLDivElement | null, index: number) => {
    sectionRefs.current[index] = el;
  };

  return (
    <div className="min-h-screen bg-white font-sans">
      <Navbar />

      {/* Hero */}
      <section className="relative h-[55vh] min-h-[400px] flex items-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=large%20Grove%20all%20terrain%20mobile%20crane%20yellow%20and%20blue%20heavy%20lifting%20equipment%20on%20construction%20site%20Chile%20clear%20blue%20sky%20industrial%20yard%20professional%20photography%20wide%20angle%20dramatic%20perspective%20steel%20boom%20extended&width=1600&height=700&seq=hero-gruagrove-v3&orientation=landscape"
            alt="Arriendo de Maquinarias"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#0d1b26]/85 via-[#0d1b26]/60 to-transparent" />
        </div>
        <div className="relative z-10 w-full max-w-7xl mx-auto px-6">
          <span className="inline-block bg-orange-500 text-white text-xs font-bold uppercase tracking-widest px-4 py-1.5 rounded-full mb-4">
            Equipos disponibles
          </span>
          <h1 className="text-5xl md:text-6xl font-extrabold text-white leading-tight">
            Arriendo de<br />
            <span className="text-orange-400">Maquinarias</span>
          </h1>
          <p className="mt-4 text-gray-200 text-lg max-w-xl">
            Flota de grúas todo terreno GROVE de alta capacidad para todo tipo de proyecto industrial y de construcción.
          </p>
        </div>
      </section>

      {/* Grid de maquinarias */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div
            ref={(el) => addRef(el, 0)}
            className="opacity-0 translate-y-8 transition-all duration-700 text-center mb-14"
          >
            <span className="inline-block bg-orange-50 text-orange-600 text-xs font-bold uppercase tracking-widest px-4 py-1.5 rounded-full mb-4">
              Nuestra Flota
            </span>
            <h2 className="text-3xl md:text-4xl font-extrabold text-[#1c2b38]">
              Grúas Todo Terreno GROVE
            </h2>
            <p className="text-gray-500 mt-3 max-w-xl mx-auto text-sm">
              Equipos certificados con mantención programada y operadores especializados disponibles.
            </p>
          </div>

          <div
            ref={(el) => addRef(el, 1)}
            className="opacity-0 translate-y-8 transition-all duration-700 delay-100 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-7"
          >
            {maquinarias.map((m) => (
              <div
                key={m.id}
                className="bg-white rounded-2xl border border-gray-100 overflow-hidden hover:-translate-y-1 hover:border-orange-200 transition-all duration-300 group"
              >
                {/* Imagen */}
                <div className="relative overflow-hidden bg-gray-100">
                  {m.img.startsWith("PENDIENTE") ? (
                    <div className="h-52 flex flex-col items-center justify-center gap-2 bg-gray-50">
                      <div className="w-12 h-12 flex items-center justify-center rounded-full bg-orange-100">
                        <i className="ri-image-add-line text-orange-400 text-2xl" />
                      </div>
                      <p className="text-xs text-gray-400 font-medium">Imagen pendiente de carga</p>
                    </div>
                  ) : (
                    <img
                      src={m.img}
                      alt={m.nombre}
                      className="w-full object-contain group-hover:scale-105 transition-transform duration-500"
                    />
                  )}
                  <div className="absolute top-3 left-3 flex gap-2">
                    <span className="bg-[#0d1b26]/80 text-white text-xs font-semibold px-3 py-1 rounded-full">
                      Grúas
                    </span>
                    {m.mostrarPatente !== false && (
                      <span className="bg-orange-500/90 text-white text-xs font-semibold px-3 py-1 rounded-full">
                        {m.patente}
                      </span>
                    )}
                  </div>
                </div>

                {/* Contenido */}
                <div className="p-6">
                  <h3 className="text-[#1c2b38] font-bold text-base mb-1">{m.nombre}</h3>
                  <p className="text-xs text-orange-500 font-semibold mb-3 uppercase tracking-wide">
                    Color: {m.color}{m.mostrarPatente !== false && ` · Patente: ${m.patente}`}
                  </p>
                  <p className="text-gray-500 text-sm leading-relaxed mb-4">{m.desc}</p>
                  <div className="flex flex-wrap gap-2 mb-5">
                    {m.tags.map((tag) => (
                      <span
                        key={tag}
                        className="bg-orange-50 text-orange-600 text-xs font-semibold px-3 py-1 rounded-full"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                  <Link
                    to="/contacto"
                    className="whitespace-nowrap w-full flex items-center justify-center gap-2 bg-[#1c2b38] hover:bg-orange-500 text-white text-sm font-semibold py-2.5 rounded-xl transition-all duration-200 cursor-pointer"
                  >
                    Solicitar cotización
                    <i className="ri-arrow-right-line" />
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Por qué elegirnos */}
      <section className="py-20 bg-[#f7f8fa]">
        <div className="max-w-7xl mx-auto px-6">
          <div
            ref={(el) => addRef(el, 2)}
            className="opacity-0 translate-y-8 transition-all duration-700 text-center mb-14"
          >
            <span className="inline-block bg-orange-50 text-orange-600 text-xs font-bold uppercase tracking-widest px-4 py-1.5 rounded-full mb-4">
              ¿Por qué elegirnos?
            </span>
            <h2 className="text-4xl font-extrabold text-[#1c2b38]">Nuestras Ventajas</h2>
          </div>
          <div
            ref={(el) => addRef(el, 3)}
            className="opacity-0 translate-y-8 transition-all duration-700 delay-100 grid grid-cols-1 md:grid-cols-3 gap-8"
          >
            {[
              { icon: "ri-shield-check-line", title: "Equipos Certificados", desc: "Toda nuestra maquinaria cuenta con certificaciones vigentes y mantención preventiva programada." },
              { icon: "ri-time-line", title: "Disponibilidad 24/7", desc: "Atención y soporte técnico disponible en todo momento para tus proyectos." },
              { icon: "ri-user-star-line", title: "Operadores Expertos", desc: "Contamos con operadores certificados y con amplia experiencia en el rubro." },
            ].map((v) => (
              <div key={v.title} className="bg-white rounded-2xl p-8 border border-gray-100 text-center">
                <div className="w-16 h-16 flex items-center justify-center rounded-2xl bg-orange-50 mx-auto mb-5">
                  <i className={`${v.icon} text-2xl text-orange-500`} />
                </div>
                <h3 className="text-[#1c2b38] font-bold text-lg mb-3">{v.title}</h3>
                <p className="text-gray-500 text-sm leading-relaxed">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
